import { mutatorAction } from 'satcheljs';
import { MailboxInfo, getRoutingKeyPrefixForSmtpAddress } from 'owa-client-ids';
import PublicFolderRequestInit from 'owa-public-folder-favorite/lib/services/utils/PublicFolderRequestInit';
import publicFolderFavoriteStore from 'owa-public-folder-favorite/lib/store/publicFolderFavoriteStore';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import getStore from '../store/store';

export default function getPublicFolderMailboxInfo(folderId: string): MailboxInfo {
    if (!getStore().has(folderId)) {
        const sourceFolder = publicFolderFavoriteStore.folderTable.get(folderId);
        const publicFolderMailbox =
            sourceFolder.ReplicaList != undefined
                ? sourceFolder.ReplicaList[0]
                : getUserConfiguration().SessionSettings.DefaultPublicFolderMailbox;
        const publicFolderMailboxInfo: MailboxInfo = {
            type: null,
            deprecatedMailboxId: folderId,
            primarySmtpAddress: sourceFolder.principalSMTPAddress,
            routingKey: getRoutingKeyPrefixForSmtpAddress() + publicFolderMailbox,
            returnModernConversationItems: null,
            requestOptions: PublicFolderRequestInit(publicFolderMailbox),
        };

        addToStore(folderId, publicFolderMailboxInfo);
    }

    return getStore().get(folderId);
}

const addToStore = mutatorAction(
    'addPublicFolderMailboxInfoToStore',
    (folderId: string, publicFolderMailboxInfo: MailboxInfo) => {
        getStore().set(folderId, publicFolderMailboxInfo);
    }
);
